import { render } from "./FactorSelector.vue?vue&type=template&id=3145cf10&scoped=true&ts=true"
import script from "./FactorSelector.vue?vue&type=script&lang=ts"
export * from "./FactorSelector.vue?vue&type=script&lang=ts"

import "./FactorSelector.vue?vue&type=style&index=0&id=3145cf10&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3145cf10"]])

export default __exports__